import toast from 'react-hot-toast';

/**
 * Antwoord van de server lezen zónder stille fouten (brede analyse FE-06, besluit Joris 6 sep).
 *
 * `r.json()` direct op een mislukte response gaf op ~130 plekken een lege lijst of een 0
 * in plaats van een melding: een 500, een cold start (HTML-antwoord) of een JSON-foutbody
 * werd stil als "geen data" getoond. Gebruik:
 *
 *   const data = await leesJson(r, 'Taken laden');
 *   ...
 *   catch (e) { meldFout(e, 'Taken laden'); setTaken([]); }
 */
export async function leesJson(r, wat = 'Laden') {
  if (!r.ok) {
    let detail = '';
    try {
      const d = await r.clone().json();
      detail = d?.detail || d?.error || d?.melding || d?.message || '';
      if (detail && typeof detail === 'object' && detail.melding) detail = detail.melding; // EU-verwerking: {code: 'wacht_eu', melding}
      if (detail && typeof detail !== 'string') detail = JSON.stringify(detail);
    } catch { /* geen JSON-body (bv. HTML van een cold start) */ }
    const fout = new Error(`${wat} mislukt (${r.status})${detail ? `: ${String(detail).slice(0, 160)}` : ''}`);
    fout.status = r.status;
    throw fout;
  }
  try { return await r.json(); }
  catch { throw new Error(`${wat} mislukt: onleesbaar antwoord van de server`); }
}

/** Fout zichtbaar maken: één toast met een leesbare tekst (nooit stil). */
export function meldFout(e, wat) {
  const tekst = e?.message || `${wat || 'Actie'} mislukt`;
  toast.error(tekst, { id: `fout-${tekst.slice(0, 60)}` }); // zelfde tekst = één toast
  return tekst;
}
